export default "__VITE_ASSET__RHQQ54Jg__"